import { fetchApi } from '@/config/axiosSetting';

export const sampleWages = (params: {
  name?: string;
  vehicleType?: string;
}): Promise<{ id: number; name: string }[]> =>
  fetchApi.get('/selection_item/wages_sample/wop_list/', {
    params: {
      name: params?.name,
      vehicle_type: params?.vehicleType,
    },
  });
